<template lang="pug">
  .pdp-transactional-info
    .qty-edit.flex-box.center-minor-axis.flex-start-major-axis(v-if="showQtyEdit")
      span.xs-mr-75m.xs-f-small.max-at-tweak.upper(aria-label="quantity") qty:
      QtyButtons(:qty="qty" @qtyChange="setQty")
      span.price.flex-fill.text-right.xs-f-small.max-at-tweak.bold(
        v-if="!displayTwoPrices"
        tabindex="0"
      ) #[strike.ui-color-6(v-if="strikedPrice") {{ $currency(strikedPrice) }}] {{ $currency(price) }}

    PdpPromotionalMessages

</template>

<script>
  import { mapState, mapMutations, mapGetters } from "vuex";
  import QtyButtons from "../../QtyButtons";
  import PdpPromotionalMessages from "../PdpPromotionalMessages";

  export default {
    name: "PdpTransactionalInfo",

    components: {
      QtyButtons,
      PdpPromotionalMessages
    },

    computed: {
      ...mapState('pdp', ['product', 'qty']),
      ...mapGetters('pdp', ['displayTwoPrices']),
      ...mapState('cms', ['cmsSettings']),

      showQtyEdit() {
        return !this.cmsSettings || !this.cmsSettings.hideQty;
      },

      strikedPrice(){
        if (this.product.oneTimeStrikePrice && this.product.oneTimeStrikePrice !== this.product.price){
          return this.product.price;
        } else {
          return false;
        }
      },

      price(){
        if (this.strikedPrice){
          return this.product.oneTimeStrikePrice;
        } else {
          return this.product.price;
        }
      }
    },

    methods: {
      ...mapMutations('pdp', ['setQty'])
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-transactional-info
    .qty-edit
      > *
        display inline-block

    @media mq-tablet-less
      padding 0 5%
      padding-top 1em

</style>